import React from "react";
import "./Achivements.css";

const achievements = [
  {
    type:"trophy",
    text:"Second Place — Cross Product Agentic AI Solution @ Ciena's Internal Hackathon"
  },
  {
    type: "trophy",
    text: "First Place — Frontend Web Development Competition",
  },
];

const certifications = [
  {
    issuer: "Ciena",
    text: "Blue Planet Inventory Developer",
  },
  {
    issuer: "Neo4j",
    text: "Neo4j Certified Professional",
  },
  {
    issuer: "Cisco",
    text: "CCNA: Introduction to Networks",
  },
  {
    issuer: "IIT Kharagpur",
    text: "Software Testing",
  },
];

const TrophyIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4a2 2 0 0 1-2-2V5h4"/><path d="M18 9h2a2 2 0 0 0 2-2V5h-4"/>
    <path d="M12 17v4"/><path d="M8 21h8"/>
    <path d="M6 3h12v8a6 6 0 0 1-12 0V3z"/>
  </svg>
);

const CertIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
  </svg>
);

const Achivements = () => {
  return (
    <div className="ACbox">
      <div className="ACheading">Achievements &<br />Certificates</div>

      <div className="ABox">

        {/* Achievements */}
        <div className="ASection">
          <div className="ASectionLabel">
            <TrophyIcon />
            Achievements
          </div>
          {achievements.map((item, i) => (
            <div className="ARow ARow--achievement" key={i}>
              <span className="ARowDot ARowDot--gold" />
              <span className="ARowText">{item.text}</span>
            </div>
          ))}
        </div>

        <div className="ADivider" />

        {/* Certifications */}
        <div className="ASection">
          <div className="ASectionLabel">
            <CertIcon />
            Certifications
          </div>
          {certifications.map((item, i) => (
            <div className="ARow" key={i}>
              <span className="ARowDot" />
              <div className="ARowBody">
                <span className="ARowText">{item.text}</span>
                <span className="ARowIssuer">{item.issuer}</span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Achivements;